import React from 'react'

const Loading = () => {
  return <span className="my-24 loading loading-spinner loading-xl border-2"></span>;
}

export default Loading